export const nonBeneficialOwnerLabel = 'Not Disclosed';
